import React from 'react';

// TODO: PartyNotFound page view
const PartyNotFound = () => {
    return <h1>Party not found, please be sure you are accessing to a correct link</h1>;
};

export default PartyNotFound;
